module.exports = __webpack_public_path__ + "img/Verschüttete_Person.3cd25084.svg";